/**
 * ALL NEW MODULES OR MODULES WITH NEW FEATURES GO HERE
 *
 * Add new modules that are safe to add to site even when old JavaScript is around.
 * Use this for all new features / non-conflicting scripts
 */

import $ from 'jquery';
import branchBar from '../branch-bar';
import navigation from '../navigation';
import hero2018 from '../hero-2018';
import buttons from '../buttons';
import video from '../video';
import fileInput from '../file-input';
import FileUploader from '../file-uploader';
import select from '../select';
import gdpr from '../gdpr';
import conversion from '../conversion';
import productHero from '../product-hero.js';
import lazyLoadMedia from '../lazy-load-media.js';
import toggle from '../toggle.js';
import tabbedContent from '../tabbed-content.js';
import shareButtons from '../share-buttons.js';
import siteQuickSearch from '../site-quick-search';
import '../form-token-refresh';
import '../hero-2022';
import '../google-maps-api-loader';
import goBack from '../go-back';
import locationPrompts from '../location-prompts';
import siteTools from '../site-tools';
import storage from '../storage';
import shims from '../shims';
import orderNewsletter from '../order-newsletter-popup';
import seasonDependingContent from '../season-depending-content';
import Form from '../form';
import { initFormAnalytics } from '../form-analytics';

// Swap "Section / columns" custom element h3 + img => img + h3
const imagesBeforeHeadings = {
  init: function () {
    $('section.columns-section .columns [class*="column-"] h3:first-child + p:has(img)').each(function () {
      $(this).toggleClass('image-first').toggleClass('jsModified');
    });
  }
};

const coreModules = {
  init() {
    $(':root').toggleClass('js',true).toggleClass('noscript',false);

    shims.init();
    branchBar.init();
    navigation.init();
    siteQuickSearch.init();
    siteTools.init();
    locationPrompts.init();
    hero2018.init();
    storage.init();
    buttons.init();
    select.init();
    fileInput.init();
    imagesBeforeHeadings.init();
    video.init();
    gdpr.init();
    conversion.init();
    productHero.init();
    lazyLoadMedia.init();
    toggle.init();
    tabbedContent.init();
    goBack.init();
    shareButtons.init();
    orderNewsletter.init();
    seasonDependingContent.init();
    initFormAnalytics();

    document.querySelectorAll('form.js-stage-form').forEach(form => {
      new Form(form);
    });

    document.querySelectorAll('.js-file-uploader').forEach(fileInput => {
      new FileUploader(fileInput);
    });


    /**
     * Initialize sliders
     *
     * NOTE: more options can be added to the options object to customize the slider
     *
     */
    const blockSlider = document.querySelectorAll('.section-block-slider');

    if (blockSlider.length) {
      const options = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled',
        },
        a11y: {
          containerMessage: 'Block slider',
        },
        preloadImages: false,
        lazy: true,
        speed: 400,
        autoHeight: false
      }
      import(/* webpackChunkName: "slider", webpackMode: "lazy" */'../commonSlider/commonSlider.js').then(m => {
        blockSlider.forEach((slider, index) => {
          m.init(slider, options, 'block-swiper', index );
        });

      });
    }

    //new product awards slider
    const productAwardsSlider = document.querySelectorAll('.section-product-awards-slider ');

    if (productAwardsSlider.length) {
      const options = {
        navigation: {
          nextEl: '.swiper-arrow-next',
          prevEl: '.swiper-arrow-prev',
          disabledClass: 'swiper-arrow-disabled',
        },
        a11y: {
          containerMessage: 'Product awards slider',
        },
        pagination: {
          enabled: false
        },
        preloadImages: true,
        slidesPerView: 'auto',
        autoHeight: false
      }
      import(/* webpackChunkName: "slider", webpackMode: "lazy" */'../commonSlider/commonSlider.js').then(m => {
        productAwardsSlider.forEach((slider, index) => {
          m.init(slider, options, 'product-award-swiper', index );
        });
      });

    }


    //new innovation slider
    const productInnovationsSliders = document.querySelectorAll('.section-product-innovations-slider');

    if (productInnovationsSliders.length) {
      const options = {
        a11y: {
          containerMessage: 'Product innovations slider',
        },
      }
      import(/* webpackChunkName: "slider", webpackMode: "lazy" */'../commonSlider/commonSlider.js').then(m => {
        productInnovationsSliders.forEach((slider, index) => {
          m.init(slider, options, 'innovation-swiper', index );
        });
      });
    }

    //new section slider
    const sectionSliders = document.querySelectorAll('.section-slider');

    if (sectionSliders.length) {
      const options = {
        a11y: {
          containerMessage: 'Section slider',
        },
      }
      import(/* webpackChunkName: "slider", webpackMode: "lazy" */'../commonSlider/commonSlider.js').then(m => {
        sectionSliders.forEach((slider, index) => {
          m.init(slider, options, 'section-swiper', index );
        });
      });
    }

    const sliders = document.querySelectorAll('.js-slider');

    if(sliders.length) {
      const options = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        a11y: {
          containerMessage: 'Slider',
        },
        slidesPerView: 1, //'auto',
        centeredSlides: true,
        spaceBetween: 30,
        autoHeight: false
      }
      import(/* webpackChunkName: "slider", webpackMode: "lazy" */'../commonSlider/commonSlider.js').then(m => {
        sliders.forEach((slider, index) => {
          m.init(slider, options, 'js-swiper', index );
        });
      });
    }

    const tooltips = document.getElementsByClassName('js-tooltip');
    if(tooltips.length) {
      import(/* webpackChunkName: "tooltip", webpackMode: "lazy" */'../tooltip/tooltip').then(m => {
        for (let tooltip of tooltips) {
          m.init(tooltip);
        }
      });
    }

    const interactiveImages = document.getElementsByClassName('js-interactive-image');
    if(interactiveImages.length) {
      import(/* webpackChunkName: "interactive-image", webpackMode: "lazy" */'../interactive-image').then(m => {
        for (let image of interactiveImages) {
          m.init(image);
        }
      });
    }

    const modals = document.querySelectorAll('[data-modal], [data-modal-v2]');
    if (modals.length) {
      import(/* webpackChunkName: "modal", webpackMode: "lazy" */'../modal').then(m => {
        m.default.init(modals);
      });
    }

    const tireSizes = document.querySelector('.tire-sizes');
    if (tireSizes) {
      import(/* webpackChunkName: "tire-sizes", webpackMode: "lazy" */'../tire-sizes').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Accordion article
    if (document.querySelector('.js-accordion-article')) {
      import(/* webpackChunkName: "accordion-article", webpackMode: "lazy" */'../accordion-article').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Phone input
    if (document.querySelector('input.validateTel')) {
      import(/* webpackChunkName: "intl-tel-input", webpackMode: "lazy" */'../intl-tel-input').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Video gallery
    if (document.querySelector('.content a.gallery-grid-item-thumbnail')) {
      import(/* webpackChunkName: "video-gallery", webpackMode: "lazy" */'../video-gallery').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Image gallery
    if (document.querySelector('.image-gallery-component, .photoset')) {
      import(/* webpackChunkName: "gallery", webpackMode: "lazy" */'../gallery').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Search page
    if (document.querySelector('.site-search-v2')) {
      import(/* webpackChunkName: "site-search", webpackMode: "lazy" */'../site-search-v2').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Triathlon
    if(document.getElementById('exercise-chart') || document.getElementsByClassName('triathlon-form').length){
      import(/* webpackChunkName: "exercise-chart", webpackMode: "lazy" */'../triathlon').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // CSR charts
    if(document.querySelectorAll('.highcharts-chart').length){
      import(/* webpackChunkName: "highcharts-chart", webpackMode: "lazy" */'../csr-charts').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Combodate
    if(document.querySelectorAll('input.combodate').length){
      import(/* webpackChunkName: "input-combodate", webpackMode: "lazy" */'../combodate-selects').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Dealer list
    if(document.querySelectorAll('.dealer-list').length){
      import(/* webpackChunkName: "dealer-list", webpackMode: "lazy" */'../dealer-list').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Dealer map (react app)
    if(document.querySelectorAll('#dealers').length){
      import(/* webpackChunkName: "dealers-react", webpackMode: "lazy" */
        '../../dealers').then(m => {
        console.log('dealers.init()');
      });
    }

    // Form fill element
    if(document.querySelectorAll('.js-form-fill').length){
      import(/* webpackChunkName: "form-fill", webpackMode: "lazy" */'../form-fill').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    //Trigger Analytics
    if(document.querySelectorAll('.js-trigger-analytics').length){
      import(/* webpackChunkName: "trigger-analytics", webpackMode: "lazy" */'../trigger-analytics').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Hatch
    const hatch = window.hatchInit === '1';
    if(hatch){
      import(/* webpackChunkName: "hatch", webpackMode: "lazy" */'../hatch').then(m => { // jshint ignore:line
        m.default.init();
      });
    }

    // Media gallery elements
    const mediaGalleries = document.querySelectorAll('[data-media-gallery]');
    if(mediaGalleries.length > 0){
      import(/* webpackChunkName: "media-gallery", webpackMode: "lazy" */'../media-gallery').then(m => { // jshint ignore:line
        for (let el of mediaGalleries) {
          m.init(el);
        }
      });
    }

    const faqs = document.querySelector('div.toggle_button, .faqs.v-2018');
    if (faqs) {
      import(/* webpackChunkName: "nt-faq", webpackMode: "lazy" */'../faq').then(m => { // jshint ignore:line
        m.default.init();
      });
    }
  }
};

export default coreModules;
